import React from "react";
import { RouterProvider } from "react-router-dom";

import AppProviders from "app/providers/AppProviders";
import appRouter from "app/routes";

const App = () => (
  <AppProviders>
    <div className="appLayout">
      <div className="appLayoutContent">
        <RouterProvider router={appRouter} />
      </div>
    </div>
  </AppProviders>
);

export default App;
